import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

// ── 支援語言清單（給 UI 使用）─────────────────────────────────────────────────
export const SUPPORTED_LANGS = [
  { code: 'zh-TW', label: 'TW 繁體中文', flag: '🇹🇼', region: 'zh-TW / zh-HK', short: 'TW' },
  { code: 'en',    label: 'EN English',  flag: '🇺🇸', region: 'en-US / en-GB', short: 'EN' },
  { code: 'ja',    label: 'JP 日本語',   flag: '🇯🇵', region: 'ja-JP',         short: 'JP' },
  { code: 'ko',    label: 'KO 한국어',   flag: '🇰🇷', region: 'ko-KR',         short: 'KO' },
  { code: 'fr',    label: 'FR Français', flag: '🇫🇷', region: 'fr',            short: 'FR' },
  { code: 'de',    label: 'DE Deutsch',  flag: '🇩🇪', region: 'de',            short: 'DE' },
  { code: 'es',    label: 'ES Español',  flag: '🇪🇸', region: 'es',            short: 'ES' },
  { code: 'it',    label: 'IT Italiano', flag: '🇮🇹', region: 'it',            short: 'IT' },
] as const

export type LangCode = typeof SUPPORTED_LANGS[number]['code']

// AI 翻譯 API 的目標語言代碼對應
export const LANG_TO_AI_TARGET: Record<LangCode, string> = {
  'zh-TW': 'zh-TW',
  'en':    'en',
  'ja':    'ja',
  'ko':    'ko',
  'fr':    'fr',
  'de':    'de',
  'es':    'es',
  'it':    'it',
}

// 由 webpack DefinePlugin 注入；每次 build 換值，CDN 認新 URL 不命中舊 cache
declare const __APP_VERSION__: string

// ── i18next-http-backend：當前語言才 fetch，省 ~459K 啟動 bundle ─────────────
// locales/* 由 webpack CopyWebpackPlugin 從 src/locales 複製到 dist/locales
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${__APP_VERSION__}`,
    },
    ns: ['common', 'auth', 'dashboard', 'trips', 'ai', 'points', 'legal', 'tasks', 'support', 'achievements', 'profile', 'rewards', 'expenses'],
    defaultNS: 'common',
    // fr/de/es/it 沒有自己的 legal.json → fallback 到 en（不要 fallback 到 zh-TW）
    // 其他歐語/非中文語言缺翻譯也優先 fallback 到 en
    fallbackLng: {
      fr: ['en', 'zh-TW'],
      de: ['en', 'zh-TW'],
      es: ['en', 'zh-TW'],
      it: ['en', 'zh-TW'],
      default: ['zh-TW'],
    },
    supportedLngs: SUPPORTED_LANGS.map((l) => l.code),
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'pixeltravel-lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    // 啟動時不 block render（Suspense 由 react-i18next 處理）；首屏可能瞬閃 key
    react: { useSuspense: true },
  })

// 同步 <html lang> 給瀏覽器原生控件（如 input[type=date] 的「年/月/日」placeholder）
i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') document.documentElement.lang = lng
})
if (typeof document !== 'undefined' && i18n.language) {
  document.documentElement.lang = i18n.language
}

export default i18n
